import styled from "styled-components";

export const Header = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
`
export const Header__logoContainer = styled.div `
    display: flex;
    align-items: center;
`
export const Header__logoContainer_p = styled.p `
    font-size: 20px;
    color: #5f6368;
    margin-left: 5px;
`
export const Header__icons = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 20px;
    color: #5f6368;
    cursor: pointer;
`
export const Hero__title = styled.h1 `
    font-size: 2.75rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 3.25rem;
    max-width: 500px;
`
export const Hero_buttons = styled.div `
    margin: 30px 0;
`
export const Hero__learnMore = styled.p `
    margin-top: 30px;
    color: #5f6368;
`
